(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plc-flipd-logo"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    document.querySelectorAll('[data-plc-flipd-auto-flip]').forEach(logo => {
      const root = logo.closest('#plc-site');
      if (!root || logo.dataset.plcFlipdInitialized === 'true') return;
      logo.dataset.plcFlipdInitialized = 'true';
      const entrance = root.querySelector('#plc-entrance');
      const popup = root.querySelector('#plc-signup');
      const refresh = () => {
        const ready = !document.hidden &&
          !root.classList.contains('plc-entry-pending') &&
          (!entrance || entrance.dataset.state === 'complete') &&
          (!popup || popup.hidden);
        logo.classList.toggle('plc-flipd-flip-ready', ready);
      };
      const observer = new MutationObserver(refresh);
      observer.observe(root, { attributes: true, attributeFilter: ['class'] });
      if (entrance) observer.observe(entrance, { attributes: true, attributeFilter: ['data-state'] });
      if (popup) observer.observe(popup, { attributes: true, attributeFilter: ['hidden'] });
      document.addEventListener('visibilitychange', refresh);
      window.addEventListener('pageshow', refresh);
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('plc:page-ready', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plc-store-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ps-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ps-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plc-store-home"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',event=>{
 if(event.key==='Escape')document.querySelectorAll('.pe-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});
 if(event.key==='Escape'){
  const directory=event.target.closest('[data-pe-directory]');
  const toggle=directory?.querySelector('.pe-directory-toggle[aria-expanded="true"]');
  if(toggle){toggle.click();toggle.focus();}
 }
});
document.addEventListener('click',event=>{
 document.querySelectorAll('.pe-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
 const toggle=event.target.closest('.pe-directory-toggle');
 if(!toggle)return;
 const directory=toggle.closest('[data-pe-directory]');
 if(!directory)return;
 const opening=toggle.getAttribute('aria-expanded')!=='true';
 directory.querySelectorAll('.pe-directory-toggle').forEach(button=>{
  const expanded=button===toggle&&opening;
  button.setAttribute('aria-expanded',String(expanded));
  button.querySelector('.pe-directory-symbol').textContent=expanded?'−':'+';
  const panel=directory.querySelector('#'+CSS.escape(button.getAttribute('aria-controls')));
  if(panel)panel.hidden=!expanded;
 });
});
  } catch(e) { console.error(e); }
})();

})();
